import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=2fe8c18c&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=js&"
export * from "./Legal.vue?vue&type=script&lang=js&"
import style0 from "./Legal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Legal.vue?vue&type=style&index=1&id=2fe8c18c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8c18c",
  null
  
)

export default component.exports